<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>Add DNS Server</h4>
      </div>
    </div>

    <div class="row">
      <div class="col-8">
        <form>
          <div class="form-group">
            <label>Server</label>
            <input type="text" class="form-control" v-model="dns_server.address">
          </div>
          <br><br>
          <button type="submit" class="btn btn-hub-primary" @click="save()">Submit</button>
          <router-link :to="{ name: 'AdminMachineDNSIndex' }" class="btn btn-secondary">Cancel</router-link>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'networkAdd',
  data: function () {
    return {
      dns_server: {
        'address': ''
      }
    }
  },
  methods: {
    save () {
      this.$store.dispatch('addDNSServer', this.dns_server)
    }
  }
}
</script>

<style scoped>

</style>
